import store from '@/store'
import getNameById from './getSelectNameById'

// 根据项目信息生成标签
export default function getProjectTags(data,type) {
  const {
    project_license_id,
    project_category_id,
    sense_ids,
    framework_ids,
    hardware_ids,
    software_ids,
    language_ids,
    label_ids,
    is_train,
    is_infer
  } = data
  // License
  let project_license_name = {
    name: getNameById(store.state.selectOptions.license, project_license_id),
    id: project_license_id,
    type: 'project_license_id'
  }
  // 模型类型
  let project_category_name = {
    name: getNameById(store.state.selectOptions.modelType, project_category_id),
    id: project_category_id,
    type: 'project_category_id'
  }
  // 应用场景
  let sense_names = []
  sense_ids.forEach((i) => {
    sense_names.push({
      name: getNameById(store.state.selectOptions.applicationScenario, i),
      id: i,
      type: 'project_scene_ids'
    })
  })
  // 支持框架
  let framework_names = []
  framework_ids.forEach((i) => {
    framework_names.push({
      name: getNameById(store.state.selectOptions.frameWork, i),
      id: i,
      type: 'project_framework_ids'
    })
  })
  // 支持硬件
  let hardware_names = []
  hardware_ids.forEach((i) => {
    hardware_names.push({
      name: getNameById(store.state.selectOptions.supportHardware, i),
      id: i,
      type: 'project_hardware_ids'
    })
  })
  // 支持软件
  let software_names = []
  software_ids.forEach((i) => {
    software_names.push({
      name: getNameById(store.state.selectOptions.supportToolSoftware, i),
      id: i,
      type: 'project_software_ids'
    })
  })
  // 语言
  let language_names = []

  if (language_ids) {
    language_ids.forEach((i) => {
      language_names.push({
        name: getNameById(store.state.selectOptions.language, i),
        id: i,
        type: 'project_language_ids'
      })
    })
  }
  // 标签
  let label_names = []
  label_ids.forEach((i) => {
    label_names.push({
      name: getNameById(store.state.selectOptions.label, i),
      id: i,
      type: 'project_label_ids'
    })
  })
  // 支持训练、推理
  let is_train_name = {
    name: getNameById(store.state.selectOptions.isSupport, is_train) + '训练',
    id: is_train,
    type: 'is_train'
  }
  let is_infer_name = {
    name: getNameById(store.state.selectOptions.isSupport, is_infer) + '推理',
    id: is_infer,
    type: 'is_infer'
  }

  // 拼装成tags
  let tags = [
    project_license_name,
    project_category_name,
    ...sense_names,
    ...framework_names,
    ...hardware_names,
    ...software_names,
    ...language_names,
    ...label_names
  ]
  // if(type=='MD'||type=='DD'){
  //   tags.push(is_train_name, is_infer_name)
  // }

  let tags2 = [
    project_license_name,
    project_category_name
  ]
  let tags3 = [
    project_category_name,
    ...sense_names,
    ...framework_names
  ]
  let tags4 = [
    project_category_name,
    project_license_name
  ]
  if(type=='C'){
    return tags2
  }else if(type=='M'||type=='D'){
    return tags4
  }else if(type=='CD'){
    return tags3
  }else if(type=='MD'||type=='DD'){
    return tags
  }
  
}
